import styled from "@emotion/styled";

export const ProductBoxImage = styled.img`
  object-fit: scale-down;
  max-width: 20%;
`;
